import React from 'react';
import './TermsOfService.scss';
import ColoredHeaderLogo from 'assets/headerAssets/svg/ColoredHeaderLogo';

const TermsOfService = () => {
    return (
        <div className="terms-of-service-container">
            <div className="terms-of-service-content">
                <div className='flex gap-2 justify-center items-center'>
                    <div
                        className="font-medium text-blue-600 dark:text-blue-500 hover:underline"
                    >
                        <ColoredHeaderLogo />
                    </div>
                </div>
                <h1>Terms of Service</h1>
                <p className="last-updated">Last Updated: February 12, 2026</p>

                <section>
                    <h2>1. Acceptance of Terms</h2>
                    <p>
                        By accessing and using InspectXpert ("the Service"), you accept and agree to be
                        bound by the terms and provision of this agreement. If you do not agree to these Terms
                        of Service, please do not use the Service.
                    </p>
                </section>

                <section>
                    <h2>2. User Accounts</h2>

                    <h3>2.1 Account Creation</h3>
                    <p>
                        To use certain features of the Service, you must register for an account. You agree to:
                    </p>
                    <ul>
                        <li>Provide accurate, current, and complete information</li>
                        <li>Maintain and update your information to keep it accurate</li>
                        <li>Maintain the security of your password</li>
                        <li>Accept all responsibility for activities under your account</li>
                        <li>Notify us immediately of any unauthorized use</li>
                    </ul>

                    <h3>2.2 Account Eligibility</h3>
                    <p>
                        You must be at least 18 years old to use this Service. If you are under 18, you
                        represent that you have your parent or guardian's permission to use the Service.
                    </p>

                    <h3>2.3 Account Termination</h3>
                    <p>
                        We reserve the right to suspend or terminate your account if you violate these Terms
                        or engage in activity that we determine to be harmful to other users or the Service.
                    </p>
                </section>

                <section>
                    <h2>3. User Responsibilities</h2>

                    <h3>3.1 Acceptable Use</h3>
                    <p>You agree not to:</p>
                    <ul>
                        <li>Use the Service for any illegal purpose or in violation of any laws</li>
                        <li>Violate or infringe other users' rights, including privacy and intellectual property</li>
                        <li>Transmit any viruses, malware, or harmful code</li>
                        <li>Attempt to gain unauthorized access to the Service or related systems</li>
                        <li>Interfere with or disrupt the Service or servers</li>
                        <li>Use automated systems to access the Service without permission</li>
                        <li>Impersonate any person or entity</li>
                        <li>Harass, abuse, or harm other users</li>
                    </ul>

                    <h3>3.2 Content Responsibility</h3>
                    <p>
                        You are responsible for all content you create, upload, or share through the Service,
                        including tickets, meeting notes, and reminders. You represent that you have all
                        necessary rights to such content.
                    </p>
                </section>

                <section>
                    <h2>4. Google Calendar Integration</h2>

                    <h3>4.1 Authorization</h3>
                    <p>
                        By connecting your Google Calendar, you authorize us to access and modify your calendar
                        on your behalf to sync tickets, meetings, and reminders created in our application.
                    </p>

                    <h3>4.2 Third-Party Service</h3>
                    <p>
                        Google Calendar is a third-party service. Your use of Google Calendar is subject to
                        Google's Terms of Service and Privacy Policy. We are not responsible for Google's
                        services or policies.
                    </p>

                    <h3>4.3 Disconnection</h3>
                    <p>
                        You may disconnect Google Calendar integration at any time from your profile settings.
                        Upon disconnection, we will immediately delete your Google access tokens.
                    </p>
                    <h3>4.4 Google API Compliance</h3>
                    <p>
                        Our access to and use of Google user data complies with the Google API Services User Data Policy,
                        including the Limited Use requirements.
                    </p>

                </section>

                <section>
                    <h2>5. Intellectual Property</h2>

                    <h3>5.1 Our Intellectual Property</h3>
                    <p>
                        The Service and its original content, features, and functionality are owned by us and
                        are protected by international copyright, trademark, patent, trade secret, and other
                        intellectual property laws.
                    </p>

                    <h3>5.2 Your Content</h3>
                    <p>
                        You retain all rights to content you create in the Service. By using the Service, you
                        grant us a license to use, modify, publicly perform, publicly display, reproduce, and
                        distribute such content solely for the purpose of providing the Service.
                    </p>

                    <h3>5.3 Feedback</h3>
                    <p>
                        Any feedback, comments, or suggestions you provide regarding the Service may be used
                        by us without any obligation to you.
                    </p>
                </section>

                <section>
                    <h2>6. Privacy and Data Protection</h2>
                    <p>
                        Your use of the Service is also governed by our{' '}
                        <a href="/privacy-policy">Privacy Policy</a>. Please review our Privacy Policy to understand
                        how we collect, use, and protect your information.
                    </p>
                </section>

                {/* <section>
                    <h2>8. Payment Terms (If Applicable)</h2>

                    <h3>8.1 Subscription Plans</h3>
                    <p>
                        Some features of the Service may require payment. Subscription fees are billed in
                        advance on a recurring basis (monthly or annually).
                    </p>

                    <h3>8.2 Refunds</h3>
                    <p>
                        Refunds are handled on a case-by-case basis. Please contact our support team to
                        discuss refund requests.
                    </p>

                    <h3>8.3 Cancellation</h3>
                    <p>
                        You may cancel your subscription at any time. Cancellations take effect at the end
                        of the current billing period.
                    </p>
                </section> */}

                <section>
                    <h2>7. Service Availability</h2>

                    <h3>7.1 Uptime</h3>
                    <p>
                        We strive to provide reliable service but do not guarantee that the Service will be
                        available at all times. The Service may be subject to:
                    </p>
                    <ul>
                        <li>Scheduled maintenance</li>
                        <li>Emergency maintenance</li>
                        <li>Technical issues beyond our control</li>
                        <li>Third-party service interruptions</li>
                    </ul>

                    <h3>7.2 Modifications</h3>
                    <p>
                        We reserve the right to modify, suspend, or discontinue any part of the Service at
                        any time with or without notice.
                    </p>
                </section>

                <section>
                    <h2>8. Limitation of Liability</h2>
                    <p>
                        TO THE MAXIMUM EXTENT PERMITTED BY LAW, IN NO EVENT SHALL WE BE LIABLE FOR ANY
                        INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES, OR ANY LOSS OF
                        PROFITS OR REVENUES, WHETHER INCURRED DIRECTLY OR INDIRECTLY, OR ANY LOSS OF DATA,
                        USE, GOODWILL, OR OTHER INTANGIBLE LOSSES, RESULTING FROM:
                    </p>
                    <ul>
                        <li>Your use or inability to use the Service</li>
                        <li>Any unauthorized access to or use of our servers and/or any personal information</li>
                        <li>Any interruption or cessation of transmission to or from the Service</li>
                        <li>Any bugs, viruses, or similar that may be transmitted through the Service</li>
                        <li>Any errors or omissions in any content or for any loss or damage incurred as a
                            result of your use of any content posted or shared through the Service</li>
                    </ul>
                </section>

                <section>
                    <h2>9. Disclaimer of Warranties</h2>
                    <p>
                        THE SERVICE IS PROVIDED "AS IS" AND "AS AVAILABLE" WITHOUT WARRANTIES OF ANY KIND,
                        WHETHER EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO:
                    </p>
                    <ul>
                        <li>Implied warranties of merchantability</li>
                        <li>Fitness for a particular purpose</li>
                        <li>Non-infringement</li>
                        <li>Accuracy, reliability, or availability</li>
                    </ul>
                </section>

                <section>
                    <h2>10. Indemnification</h2>
                    <p>
                        You agree to indemnify, defend, and hold harmless InspectXpert, its officers,
                        directors, employees, and agents from and against any claims, liabilities, damages,
                        losses, and expenses, including reasonable attorney's fees, arising out of or in any
                        way connected with:
                    </p>
                    <ul>
                        <li>Your access to or use of the Service</li>
                        <li>Your violation of these Terms</li>
                        <li>Your violation of any third-party right, including any intellectual property
                            right or privacy right</li>
                        <li>Any content you submit through the Service</li>
                    </ul>
                </section>

                <section>
                    <h2>11. Data Backup</h2>
                    <p>
                        While we implement backup procedures, you are responsible for maintaining your own
                        backups of any data you submit to the Service. We are not liable for any loss or
                        corruption of data.
                    </p>
                </section>

                <section>
                    <h2>12. Third-Party Services</h2>
                    <p>
                        The Service may contain links to third-party websites or services (such as Google
                        Calendar) that are not owned or controlled by us. We are not responsible for the
                        content, privacy policies, or practices of any third-party services.
                        We are not responsible for interruptions, errors, or changes in functionality
                        caused by third-party services such as Google Calendar or the Google Calendar API.
                    </p>
                </section>

                <section>
                    <h2>13. Governing Law and Dispute Resolution</h2>

                    <h3>13.1 Governing Law</h3>
                    <p>
                        These Terms shall be governed by and construed in accordance with the laws of
                        India, without regard to its conflict of law provisions.
                    </p>

                    <h3>13.2 Dispute Resolution</h3>
                    <p>
                        Any disputes arising from these Terms or the Service shall first be attempted to be
                        resolved through good-faith negotiation. If negotiation fails, disputes shall be
                        resolved through binding arbitration in India.
                    </p>

                    <h3>13.3 Class Action Waiver</h3>
                    <p>
                        You agree to resolve disputes with us on an individual basis and waive your right to
                        participate in any class action or representative proceeding.
                    </p>
                </section>

                <section>
                    <h2>14. Changes to Terms</h2>
                    <p>
                        We reserve the right to modify these Terms at any time. We will notify users of any
                        material changes by:
                    </p>
                    <ul>
                        <li>Posting the new Terms on this page</li>
                        <li>Updating the "Last Updated" date</li>
                        <li>Sending an email notification (for significant changes)</li>
                    </ul>
                    <p>
                        Your continued use of the Service after any changes constitutes acceptance of the new Terms.
                    </p>
                </section>

                <section>
                    <h2>15. Severability</h2>
                    <p>
                        If any provision of these Terms is held to be invalid or unenforceable, such provision
                        shall be struck and the remaining provisions shall remain in full force and effect.
                    </p>
                </section>

                <section>
                    <h2>16. Waiver</h2>
                    <p>
                        Our failure to enforce any right or provision of these Terms will not be considered a
                        waiver of those rights.
                    </p>
                </section>

                <section>
                    <h2>17. Entire Agreement</h2>
                    <p>
                        These Terms, together with our Privacy Policy, constitute the entire agreement between
                        you and us regarding the use of the Service and supersede all prior agreements.
                    </p>
                </section>

                <section>
                    <h2>18. Contact Information</h2>
                    <p>
                        If you have any questions about these Terms, please contact us:
                    </p>
                    <ul>
                        <li><strong>Email:</strong> sales@synctel.in
                        </li>
                        <li><strong>Address:</strong> 314, 3rd Floor, 99 Shopping Center, Sayan Rd, opp. Bhagunagar, Brahmani Nagar Society, Amroli</li>
                        <li><strong>Phone:</strong> +91 6358280506</li>
                    </ul>
                </section>

                <section>
                    <h2>19. Special Provisions for Enterprise Users</h2>
                    <p>
                        If you are using the Service on behalf of an organization:
                    </p>
                    <ul>
                        <li>You represent that you have authority to bind the organization to these Terms</li>
                        <li>"You" and "your" refer to both you individually and the organization</li>
                        <li>The organization agrees to indemnify us for violations by its users</li>
                        <li>Additional terms may apply as specified in your Enterprise Agreement</li>
                    </ul>
                </section>

                <section>
                    <h2>20. Export Compliance</h2>
                    <p>
                        You agree to comply with all applicable export and import laws and regulations. You
                        represent that you are not located in a country subject to a U.S. Government embargo
                        or designated as a "terrorist supporting" country.
                    </p>
                </section>

                <section className="acknowledgment">
                    <p>
                        <strong>By using InspectXpert, you acknowledge that you have read, understood,
                            and agree to be bound by these Terms of Service.</strong>
                    </p>
                </section>
            </div>
        </div>
    );
};

export default TermsOfService;